import React from "react";
import { btnGold } from "@/components/nds/windows/finance/parts";

export const CorrectionButton = ({ pc, onClick }) => (
  <button type="button" onClick={onClick} data-testid={`fin-paycheck-correction-${pc.id}`} className={btnGold}>Ledger correction</button>
);
